/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAgreementTreeNode } from './ServiceAgreementTreeNode';
import {
    ServiceAgreementTreeNodeFromJSON,
    ServiceAgreementTreeNodeFromJSONTyped,
    ServiceAgreementTreeNodeToJSON,
    ServiceAgreementTreeNodeToJSONTyped,
} from './ServiceAgreementTreeNode';

/**
 * 
 * @export
 * @interface GetServiceAgreementTreeResponse
 */
export interface GetServiceAgreementTreeResponse {
    /**
     * 
     * @type {Array<ServiceAgreementTreeNode>}
     * @memberof GetServiceAgreementTreeResponse
     */
    list?: Array<ServiceAgreementTreeNode>;
}

/**
 * Check if a given object implements the GetServiceAgreementTreeResponse interface.
 */
export function instanceOfGetServiceAgreementTreeResponse(value: object): value is GetServiceAgreementTreeResponse {
    return true;
}

export function GetServiceAgreementTreeResponseFromJSON(json: any): GetServiceAgreementTreeResponse {
    return GetServiceAgreementTreeResponseFromJSONTyped(json, false);
}

export function GetServiceAgreementTreeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetServiceAgreementTreeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'list': json['list'] == null ? undefined : ((json['list'] as Array<any>).map(ServiceAgreementTreeNodeFromJSON)),
    };
}

export function GetServiceAgreementTreeResponseToJSON(json: any): GetServiceAgreementTreeResponse {
    return GetServiceAgreementTreeResponseToJSONTyped(json, false);
}

export function GetServiceAgreementTreeResponseToJSONTyped(value?: GetServiceAgreementTreeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'list': value['list'] == null ? undefined : ((value['list'] as Array<any>).map(ServiceAgreementTreeNodeToJSON)),
    };
}

